// extracted by mini-css-extract-plugin
export default {"container":"home-achievement_container__32MW0","title":"home-achievement_title__Dwttc","logos":"home-achievement_logos__fNDT9","logos2":"home-achievement_logos2__0yvBx"};